import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-budget-status-icon",
  templateUrl: "./budget-status-icon.component.html",
  styleUrls: ["./budget-status-icon.component.scss"],
})
export class BudgetStatusIconComponent implements OnInit {
  @Input() status: string = "";

  constructor() {}

  ngOnInit(): void {}

  getStatusIcon(status: string) {
    switch (status) {
      case "under_budget":
        return "assets/Icons/arrow-up-blue.svg";
      case "over_spend":
        return "assets/Icons/arrow-down-red.svg";
      case "equal":
        return "assets/Icons/bidirectional.svg";
      default:
        return "";
    }
  }

  getStatusToolTip(status: string) {
    switch (status) {
      case "under_budget":
        return "Within Budget";
      case "over_spend":
        return "Over Budget";
      case "equal":
        return "At Budget";
      default:
        return "";
    }
  }
}
